<div class="grid gap-3 p-3">
  <div class="col-12 container">
    <div class="summary-title">Summary</div>
    <table class="summary-table">
      <tr class="summary-row">
        <td class="font-bold">Vehicle</td>
        <td>{{ quote.quoteVehicle.summary }}</td>
      </tr>
      <tr class="summary-row">
        <td class="font-bold">Pickup</td>
        <td>{{ quote.quotePickupAddress.summary }}</td>
      </tr>
      <tr class="summary-row">
        <td class="font-bold">Dropoff</td>
        <td>{{ quote.quoteDropoffAddress.summary }}</td>
      </tr>
      <tr class="summary-row">
        <td class="font-bold">Movement Type</td>
        <td>
          {{ quote.taskType.name }}
        </td>
      </tr>
    </table>
  </div>
  <div class="col-12 container">
    <div class="summary-title">Payment Summary</div>

    <table class="summary-table">
      <!--            <tr class="summary-header">-->
      <!--                <td class="font-bold">Description</td>-->
      <!--                <td class="font-bold">Amount</td>-->
      <!--            </tr>-->
      <tr *ngIf="showDiscountPrice" class="summary-row">
        <td class="font-bold">Original Quote</td>
        <td>{{ yourOriginalPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}</td>
      </tr>
      <tr *ngIf="showDiscountPrice" class="summary-row">
        <td class="font-bold">Discount</td>
        <td>-{{ yourOriginalPrice - yourQuotePrice | currency : 'GBP' : 'symbol' : '1.2-2' }}</td>
      </tr>
      <tr class="summary-row">
        <td class="font-bold">Subtotal</td>
        <td>{{ yourQuotePrice | currency : 'GBP' : 'symbol' : '1.2-2' }}</td>
      </tr>
      <tr class="summary-row">
        <td class="font-bold">VAT</td>
        <td>
          {{ yourQuotePriceWithVAT - yourQuotePrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
        </td>
      </tr>
      <tr class="summary-row">
        <td class="final-total">To Pay:</td>
        <td class="final-total">
          {{ yourQuotePriceWithVAT | currency : 'GBP' : 'symbol' : '1.2-2' }}
        </td>
      </tr>
    </table>
  </div>
</div>
